import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ng2-cookies';
import {Localiser} from "./localiser";
import {ContactService} from "./contact.service";

@Injectable({
  providedIn: 'root'
})
export class Navigation {

  situation: { situation: string, menu: string };

  constructor(private router: Router, private cookieService: CookieService,
              private localiser: Localiser, private contactService: ContactService) {

    if (cookieService.check("situation")) {
      let situationArray = cookieService.get("situation").split(",");
      this.situation = { situation: situationArray[0], menu: situationArray[1] };
    } else {
      cookieService.set("situation", "login,a");
    }

  }

  public toLogin() {
    this.situation = {situation: 'login', menu: 'a'};
    this.cookieService.set("situation", "login,a");
    this.contactService.setSituationUser("contact.situationLogin");
    this.router.navigate(["/login"]);
  }

  public toHome() {
    this.situation = {situation: 'home', menu: 'a'};
    this.cookieService.set("situation", "home,a");
    this.contactService.setSituationUser("contact.situationHomeAteneo");
    this.router.navigate(["/home"]);
  }

  public toHomeConfiguration() {
    this.situation = {situation: 'home_configuration', menu: 'c'};
    this.cookieService.set("situation", "home_configuration,c");
    this.contactService.setSituationUser("contact.situationHomeConfiguration");
    this.router.navigate(["/home_configuration"]);
  }

  public toLocations() {
    this.situation = {situation: 'locations', menu: 'a'};
    this.cookieService.set("situation", "locations,a");
    this.contactService.setSituationUser("contact.situationLocations");
    this.router.navigate(["/locations"]);
  }

  public toIndicators() {
    this.situation = {situation: 'indicators', menu: 'a'};
    this.cookieService.set("situation", "indicators,a");
    this.contactService.setSituationUser("contact.situationKPI");
    this.router.navigate(["/indicators"]);
  }

  public toIndicatorsSelection() {
    this.situation = {situation: 'indicators', menu: 'a'};
    this.cookieService.set("situation", "indicators,a");
    this.contactService.setSituationUser("contact.situationKPI");
    this.router.navigate(["/indicators_selection"]);
  }

  public toFloorplans() {
    this.situation = {situation: 'floorplans', menu: this.situation.menu};
    this.cookieService.set("situation", "floorplans," + this.situation.menu);
    this.contactService.setSituationUser("contact.situationZonesMap");
    this.router.navigate(["/floorplans"]);
  }

  public toSelectFloorplan() {
    this.situation = {situation: 'floorplans', menu: this.situation.menu};
    this.cookieService.set("situation", "floorplans," + this.situation.menu);
    this.contactService.setSituationUser("contact.situationZonesSelect");
    this.router.navigate(["/select_floorplan"]);
  }

  public toDevices() {
    this.situation = {situation: 'devices', menu: 'c'};
    this.cookieService.set("situation", "devices,c");
    this.contactService.setSituationUser("contact.situationDevices");
    this.router.navigate(["/devices"]);
  }

  public toAlerts() {
    this.situation = {situation: 'alerts', menu: 'c'};
    this.cookieService.set("situation", "alerts,c");
    this.contactService.setSituationUser("contact.situationAlerts");
    this.router.navigate(["/alerts"]);
  }

  public toAutotest() {
    this.situation = {situation: 'autotest', menu: 'a'};
    this.cookieService.set("situation", "autotest,a");
    this.contactService.setSituationUser("contact.situationAutotest");
    this.router.navigate(["/autotest"]);
  }

  public toAirfal() {
    this.situation = {situation: 'airfal', menu: 'a'};
    this.cookieService.set("situation", "airfal,a");
    this.router.navigate(["/airfal"]);
  }

  public toContactMessage() {
    this.situation = {situation: 'airfal', menu: 'a'};
    this.cookieService.set("situation", "airfal,a");
    this.router.navigate(["/contact_message"]);
  }

  public toUsers() {
    this.situation = {situation: 'users', menu: 'c'};
    this.cookieService.set("situation", "users,c");
    this.contactService.setSituationUser("contact.situationUsers");
    this.router.navigate(["/users"]);
  }

  public toReglas() {
    this.situation = {situation: 'reglas', menu: 'c'};
    this.cookieService.set("situation", "reglas,c");
    this.contactService.setSituationUser("contact.situationRules");
    this.router.navigate(["/rules"]);
  }

  public toFade() {
    this.situation = {situation: 'fade', menu: 'c'};
    this.cookieService.set("situation", "fade,c");
    this.contactService.setSituationUser("contact.situationProfiles");
    this.router.navigate(["/profiles"]);
  }

  public toProfile() {
    this.situation = {situation: 'login', menu: this.situation.menu};
    this.cookieService.set("situation", "login," + this.situation.menu);
    this.contactService.setSituationUser("contact.situationProfile");
    this.router.navigate(["/profile"]);
  }

  public toLimits() {
    this.situation = {situation: 'limits', menu: 'c'};
    this.cookieService.set("situation", "limits,c");
    this.contactService.setSituationUser("contact.situationLimits");
    this.router.navigate(["/limits"]);
  }

  public toAteneoZones() {
    this.situation = {situation: 'zones', menu: 'a'};
    this.cookieService.set("situation", "zones,a");
    this.contactService.setSituationUser("contact.situationZones");
    this.router.navigate(["/zones"]);
  }

  public toOta() {
    this.situation = {situation: 'ota', menu: 'c'};
    this.cookieService.set("situation", "ota,c");
    this.contactService.setSituationUser("contact.situationDevices");
    this.router.navigate(["/ota"]);
  }

  public toIndicatorsPresences() {
    this.situation = {situation: 'indicators', menu: 'a'};
    this.cookieService.set("situation", "indicators,a");
    this.contactService.setSituationUser("contact.situationKPI");
    this.router.navigate(["/indicators-presences"]);
  }

  public toIndicatorsSensors() {
    this.situation = {situation: 'indicators', menu: 'a'};
    this.cookieService.set("situation", "indicators,a");
    this.contactService.setSituationUser("contact.situationKPI");
    this.router.navigate(["/indicators-sensors"]);
  }

  public toReports() {
    this.situation = {situation: 'reports', menu: 'a'};
    this.cookieService.set("situation", "reports,a");
    this.contactService.setSituationUser("contact.situationReports");
    this.router.navigate(["/reports"]);
  }

  public toParameters() {
    this.situation = {situation: 'parameters', menu: 'c'};
    this.cookieService.set("situation", "parameters,c");
    this.contactService.setSituationUser("contact.situationParameters");
    this.router.navigate(["/parameters"]);
  }

  public getSituation() {
    if (this.situation == null) {
      let situationArray = this.cookieService.get("situation").split(",");
      this.situation = { situation: situationArray[0], menu: situationArray[1] };
    }
    return this.situation;
  }

}
